export default "__VITE_ASSET__B19jBE0g__"